import { render, staticRenderFns } from "./affrim-item.vue?vue&type=template&id=bfbcead6&scoped=true"
import script from "./affrim-item.vue?vue&type=script&lang=js"
export * from "./affrim-item.vue?vue&type=script&lang=js"
import style0 from "./affrim-item.vue?vue&type=style&index=0&id=bfbcead6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbcead6",
  null
  
)

export default component.exports